import { Account } from './account';
import { FinancialProduct } from './financialProduct';
import { Currencies } from './transaction';

export enum AccountReconciliationFlagTypes {
  DIFFERENT_CASH = 'DIFFERENT_CASH',
  DIFFERENT_HOLDING_QUANTITY = 'DIFFERENT_HOLDING_QUANTITY',
  DIFFERENT_HOLDING_BOOK_VALUE = 'DIFFERENT_HOLDING_BOOK_VALUE',
  DIFFERENT_HOLDING_EOD_PRICE = 'DIFFERENT_HOLDING_EOD_PRICE',
}

export enum AccountReconciliationFlagStates {
  FLAGGED = 'FLAGGED',
  FIXED = 'FIXED',
}

export interface AccountReconciliationSnapshotFlag {
  type: AccountReconciliationFlagTypes;
  description: string;
  state: AccountReconciliationFlagStates;
  financialProduct?: FinancialProduct;
  details: any;
}

export interface AccountReconciliationSnapshotHolding {
  financialProduct: FinancialProduct;
  currency: Currencies;
  ticker?: string;
  isCash: boolean;
  oneVestQuantity?: number;
  oneVestPendingQuantity?: number;
  oneVestBookValueCents?: number;
  oneVestEodPriceCents?: number;
  oneVestValueCents?: number;
  oneVestPendingValueCents?: number;
  custodianQuantity?: number;
  custodianBookValueCents?: number;
  custodianEodPriceCents?: number;
  custodianValueCents?: number;
}

export interface AccountReconciliationSnapshot {
  id: string;
  account: Account;
  date: Date;
  holdings: AccountReconciliationSnapshotHolding[];
  flags: AccountReconciliationSnapshotFlag[];
  isFlagged: boolean;
  oneVestUpdatedAt?: Date;
  custodianUpdatedAt?: Date;
}
